import { ReactElement, cloneElement } from 'react';

// project imports
import { useContextAction } from 'hooks/useContextAction';
import { ApplicableAction } from '../constants';

// types
import { ContextActionGuardProps } from 'models';
import { i18nValue } from 'utils/index';

// ==============================|| CONTEXT ACTION GUARD ||============================== //

//TODO: does not work generally, use with caution, preferably rework or stop using
const ContextActionGuard = ({
  children,
  actionCode,
  resourceEntity,
  entityIdentificator
}: ContextActionGuardProps): ReactElement => {
  const { contextAction } = useContextAction({
    actionCode,
    resourceEntity,
    entityIdentificator
  });

  const reason = i18nValue(
    `common.messages.caReasons.${contextAction?.code}.${contextAction?.reasonCode}`,
    contextAction?.reasonCode
  );

  switch (contextAction?.applicability) {
    case ApplicableAction.ENABLED:
      return <>{children}</>;
    case ApplicableAction.DISABLED:
      return (
        <>
          {cloneElement(children as ReactElement, {
            disabled: true,
            helperText: reason
          })}
        </>
      );
    default:
      return <></>;
  }
};

export default ContextActionGuard;
